export type TopNavigationConfig = {
  id: string;
  label: string;
  url: string;
  icon: string;
  exactUrl: boolean;
};

export const navTopConfigurations: TopNavigationConfig[] = [
  {
    id: "my-profile",
    label: "My profile",
    url: "/profile",
    icon: "ri-user-line ri-xl",
    exactUrl: true,
  },
  {
    id: "discovery-profile",
    label: "Discover people",
    url: "/discover",
    icon: "ri-search-line ri-xl",
    exactUrl: false,
  },
];
